import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomerReviewCard from 'components/consumer/customer-reviews-list/CustomerReviewCard';
import useScreen from 'hooks/useScreen';
import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';
const ResultsHeader = t0 => {
  const $ = _c(7);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t2 = variant === "advanced-search";
  const t3 = variant !== "mobile";
  const t4 = variant === "mobile";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = classNames("mx-0 my-2.5 text-base font-bold", {
      "hidden lg:block": t2,
      "text-gray": t3,
      "text-brand block mt-[15px] mb-[7px]": t4
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== children || $[5] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[4] = children;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
const CustomerReviews = t0 => {
  const $ = _c(19);
  const {
    variant: t1,
    forComponent
  } = t0;
  const variant = t1 === undefined ? "advanced-search" : t1;
  const {
    items,
    showMore,
    isLastPage
  } = useInfiniteHits();
  const {
    status
  } = useInstantSearch();
  const {
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? "2800px" : "2200px";
  let t2;
  if ($[0] !== items) {
    t2 = items.map(_temp);
    $[0] = items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const reviewsList = t2;
  if (!items || items.length === 0) {
    if (status === "idle") {
      let t3;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <div role="status" aria-live="polite" className="py-8 text-center">No results found.</div>;
        $[2] = t3;
      } else {
        t3 = $[2];
      }
      return t3;
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="w-full flex items-center justify-center min-h-[20vh]"><div className="text-center"><div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-2" role="status" aria-label="Loading" /></div></div>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t3 = forComponent === "mobile" ? "Results" : "Reviews";
  let t4;
  if ($[4] !== t3 || $[5] !== variant) {
    t4 = <ResultsHeader variant={variant}>{t3}</ResultsHeader>;
    $[4] = t3;
    $[5] = variant;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = !isLastPage;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h4>Loading...</h4>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== reviewsList) {
    t7 = <div data-xc="reviews-list-container">{reviewsList}</div>;
    $[8] = reviewsList;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== infiniteScrollThreshold || $[11] !== reviewsList.length || $[12] !== showMore || $[13] !== t5 || $[14] !== t7) {
    t8 = <InfiniteScroll dataLength={reviewsList.length} next={showMore} hasMore={t5} scrollThreshold={infiniteScrollThreshold} loader={t6}>{t7}</InfiniteScroll>;
    $[10] = infiniteScrollThreshold;
    $[11] = reviewsList.length;
    $[12] = showMore;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default CustomerReviews;
function _temp(hit, index) {
  return <CustomerReviewCard key={hit.review_id || hit.objectID || index} productReview={hit} type="search" variant="advanced-search" />;
}